// import * as React from "react";
import { QueryStatsRounded } from "@mui/icons-material";
import {
  Button,
  Divider,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import { Fragment, useEffect, useState } from "react";
import BigImage from "../../../components/BigImage/BigImage";
import * as echarts from "echarts";

import StyledHeader from "../../../components/StyledHeader/StyledHeader";

export default function Annotation({
  type = null,
  tableData,
  GraphParam = null,
  miniMode = null,
  pretrainNum = null,
  jobid = null,
}) {
  const [RNADNAtableData, setRNADNAtableData] = useState([]);
  const [AffinityTableData, setAffinityTableData] = useState([]);
  const [labelType, setLabelType] = useState(null);
  const residues = [
    "A",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "K",
    "L",
    "M",
    "N",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "V",
    "W",
    "Y",
  ];
  const color_residues = {
    A: "#FD776A",
    R: "darkgoldenrod",
    N: "#E35F7A",
    D: "#FB75D3",
    C: "#FFB287",
    Q: "#E87B99",
    E: "#FF0070",
    G: "#E89D66",
    H: "#FF483C",
    I: "#A4E887",
    L: "#FF8957",
    K: "#94E4FF",
    M: "#82E8C0",
    F: "#9EA4FF",
    P: "#5A67FF",
    S: "#DEA1FF",
    T: "#8F8EE8",
    W: "#A9DDFF",
    Y: "#8EE8D3",
    V: "#FF948F",
  };
  const downloadEvt = (url) => {
    const el = document.createElement("a");
    el.style.display = "none";
    el.setAttribute("target", "_blank");

    el.setAttribute("download", url);
    el.href = url;
    console.log(el);
    document.body.appendChild(el);
    el.click();
    document.body.removeChild(el);
  };
  const bar_graph = (data, domId) => {
    var chartDomBar = document.getElementById(domId);
    var myChartBar = echarts.init(chartDomBar);
    var optionBar;

    optionBar = {
      xAxis: {
        type: "category",
        data: residues,
      },
      yAxis: {
        type: "value",
      },
      label: {
        show: true,
        position: "top",
      },
      series: [
        {
          data: data,
          type: "bar",
        },
      ],
    };
    myChartBar.setOption(optionBar);
  };
  const pie_graph = (data, domId, title, legend) => {
    let chartDom = document.getElementById(domId);
    let myChart = echarts.init(chartDom);
    let option;
    option = {
      title: {
        text: title,
        left: "center",
      },
      tooltip: {
        trigger: "item",
      },
      legend: {
        orient: "vertical",
        left: "left",
      },
      series: [
        {
          name: legend,
          type: "pie",
          radius: "75%",

          label: {
            show: false,
            position: "center",
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          labelLine: {
            show: false,
          },
          data: data,
        },
      ],
    };

    myChart.setOption(option);
  };
  useEffect(() => {
    console.log(type, "type");
    if (GraphParam) {
      setGraphParam(GraphParam);
    }
    if (
      tableData?.table_data?.prot_seq &&
      tableData?.table_data?.lable &&
      (type === "1" || type === "2" || type === "3")
    ) {
      let current_sequence = {
        label: tableData.table_data.lable,
        prot_seq: tableData.table_data.prot_seq.split(""),
      };
      setProtSequence(current_sequence);
    } else if (
      tableData?.table_data?.index_list &&
      tableData?.table_data?.output_fasta &&
      tableData?.table_data?.residue_number &&
      tableData?.table_data?.result_list &&
      tableData?.table_data?.sequence_list &&
      (type === "6" || type === "8"|| type === "9")
    ) {
      let data_result_table = [];
      tableData.table_data.sequence_list.forEach((v, i, a) => {
        data_result_table.push({
          Index: tableData?.table_data?.index_list[i],
          Sequence: v,
          Result: tableData?.table_data?.result_list[i],
          id: i,
        });
      });
      // console.log(dataDNARNA);
      setRNADNAtableData(data_result_table);

      if (tableData?.table_data?.residue_number) {
        let sum_number = 0;
        residues.forEach((value) => {
          sum_number += tableData?.table_data?.residue_number[value];
        });
        let pie_data = residues.map((value) => {
          return {
            name: value,
            value: (
              tableData?.table_data?.residue_number[value] / sum_number
            ).toFixed(3),
            itemStyle: {
              color: color_residues[value],
            },
          };
        });
        let bar_data = residues.map((value) => {
          return {
            value: tableData?.table_data?.residue_number[value],
            itemStyle: {
              color: color_residues[value],
            },
          };
        });
        try {
          pie_graph(
            pie_data,
            "echart_entrence1",
            "Residue ratio chart",
            "Residue ratio"
          );
          bar_graph(bar_data, "echart_entrence2");
        } catch (error) {}
      }

      console.log(tableData?.table_data);
    } else if (
      tableData?.table_data?.dock_energies &&
      tableData?.table_data?.mol_list &&
      type === "7"
    ) {
      let data_result_table = [];
      tableData.table_data.dock_energies.forEach((v, i, a) => {
        data_result_table.push({
          index: i,
          smiles: tableData?.table_data?.mol_list[i],
          scores: tableData?.table_data?.dock_energies[i],
          id: i,
        });
      });
      setAffinityTableData(data_result_table);
    }
  }, [tableData]);

  useEffect(() => {
    // console.log();
    if (miniMode && miniMode === "default") {
      if (
        pretrainNum &&
        (String(pretrainNum) === "0" || String(pretrainNum) === "1")
      ) {
        setLabelType("C");
      } else if (pretrainNum && String(pretrainNum) === "2") {
        setLabelType("A");
      }
    }
    // console.log(type);
    // console.log(tableData);
    // console.log(GraphParam);
  });
  const [protSequence, setProtSequence] = useState(null);
  const [graphParam, setGraphParam] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const scrollingTableRow = (item) => {
    // console.log(item);
    return (
      <Fragment>
        {item.value ? (
          <div style={{ overflowX: "auto" }}>
            {item.row.Scores.map((v, i, a) => {
              let siteChar = item.row.Sequence[i];
              if (labelType) {
                if (v > 0.5 && siteChar === labelType) {
                  return <text style={{ color: "red" }}>{siteChar}</text>;
                } else {
                  return <text>{siteChar}</text>;
                }
              } else {
                if (
                  v > 0.5 &&
                  (String(siteChar) === "C" || String(siteChar) === "A")
                ) {
                  return <text style={{ color: "red" }}>{siteChar}</text>;
                } else {
                  return <text>{siteChar}</text>;
                }
              }

              // console.log()
            })}
          </div>
        ) : (
          "null"
        )}
      </Fragment>
    );
  };

  return (
    <Paper elevation={3} sx={{ overflow: "hidden", mb: 2 }}>
      <StyledHeader icon={<QueryStatsRounded />}>
        {type &&
          (type === "1" || type === "2" || type === "3") &&
          "Annotation Analysis"}
        {type && type === "6" && "Result Analysis"}
      </StyledHeader>
      {type && (type === "1" || type === "2" || type === "3") && (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Paper sx={{ p: 1, m: 2, height: 600 }} elevation={2}>
              <Typography variant="h6">Visualization in 3Dmol</Typography>
              <Divider sx={{ ml: -1, mr: -1, mt: 1 }} />
              {graphParam && (
                <iframe
                  // style={{ width: "100%", hight: "600px" }}
                  src={
                    "https://3dmol.csb.pitt.edu/viewer.html?pdb=" +
                    graphParam.pdbid +
                    "&style=none&surface=opacity:0.6;color:white&select=chain:" +
                    graphParam.chain +
                    "&style=cartoon:color~white&select=resi:" +
                    graphParam.index.toString() +
                    ";chain:" +
                    graphParam.chain +
                    "&labelres=backgroundOpacity:0.8;fontSize:8&style=cartoon:color~red"
                  }
                  width="100%"
                  height={550}
                  scrolling="no"
                  border="0"
                  frameborder="no"
                  framespacing="0"
                  allowfullscreen="true"
                ></iframe>
              )}
            </Paper>
          </Grid>
          <Grid item xs={12} sm={6}>
            {protSequence && protSequence.label && protSequence.prot_seq && (
              <Paper sx={{ p: 1, m: 2, height: 600 }} elevation={2}>
                <Typography variant="h6">
                  Summary of the input datasets
                </Typography>
                <Divider sx={{ ml: -1, mr: -1, mt: 1 }} />
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          Sequence with Binding sites(highlight in red):
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>
                          {protSequence?.label?.map((value, index) => {
                            if (value === 1) {
                              return (
                                <text
                                  style={{ color: "red", float: "left" }}
                                  key={index}
                                >
                                  {protSequence.prot_seq[index]}
                                </text>
                              );
                            } else {
                              return (
                                <text
                                  style={{ color: "black", float: "left" }}
                                  key={index}
                                >
                                  {protSequence.prot_seq[index]}
                                </text>
                              );
                            }
                          })}
                        </TableCell>
                      </TableRow>
                      <TableHead>
                        {" "}
                        <TableRow>
                          <TableCell>
                            Index of binding sites in PDB file:
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableRow>
                        <TableCell sx={{ wordBreak: "break-word" }}>
                          {graphParam?.index && graphParam?.index.toString()}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            )}
          </Grid>
        </Grid>
      )}

      {type && (type === "6" || type === "8"|| type === "9") && (
        <Paper sx={{ p: 1, m: 2 }} elevation={2}>
          <Grid container direction="row">
            <Grid item xs={11}>
              <Typography variant="h6">Statistic Analysis</Typography>
            </Grid>
          </Grid>
          <Divider sx={{ ml: -1, mr: -1, mt: 1 }} />

          <Box sx={{ flex: 1, marginBottom: 2, height: "400px" }}>
            <Box
              id="echart_entrence1"
              style={{ width: "50%", height: "400px", float: "left" }}
            ></Box>
            <Box
              id="echart_entrence2"
              style={{ width: "50%", height: "400px", float: "left" }}
            ></Box>
          </Box>
        </Paper>
      )}
      {type && (type === "6" || type === "8"|| type === "9") && (
        <Paper sx={{ p: 1, m: 2 }} elevation={2}>
          <Grid container direction="row">
            <Grid item xs={11}>
              <Typography variant="h6">Prediction Results</Typography>
            </Grid>
          </Grid>
          <Divider sx={{ ml: -1, mr: -1, mt: 1 }} />
          <Box sx={{ flex: 1, marginBottom: 2, height: "400px" }}>
            <DataGrid
              columns={[
                {
                  field: "Index",
                },
                {
                  field: "Sequence",
                  flex: 1,
                  minWidth: 170,
                },
                {
                  field: "Result",
                },
              ]}
              rows={RNADNAtableData}
            />
          </Box>
          <Button
            onClick={() => {
              if (tableData?.table_data?.output_fasta) {
                downloadEvt(tableData?.table_data?.output_fasta);
              }
            }}
          >
            Download Result
          </Button>
        </Paper>
      )}

      {type && type === "7" && (
        <Paper sx={{ p: 1, m: 2 }} elevation={2}>
          <Grid container direction="row">
            <Grid item xs={11}>
              <Typography variant="h6">Prediction Results</Typography>
            </Grid>
          </Grid>
          <Divider sx={{ ml: -1, mr: -1, mt: 1 }} />
          <Box sx={{ flex: 1, marginBottom: 2, height: "400px" }}>
            <DataGrid
              columns={[
                {
                  field: "index",
                  headerName: "Index",
                },
                {
                  field: "smiles",
                  headerName: "SMILES",

                  flex: 1,
                  minWidth: 130,
                },
                {
                  field: "scores",
                  headerName: "Affinity(kcal/mol)",
                  flex: 1,

                  minWidth: 40,
                },
              ]}
              rows={AffinityTableData}
            />
          </Box>
          <Button
            onClick={() => {
              if (tableData?.table_data?.output_fasta) {
                downloadEvt(tableData?.table_data?.output_fasta);
              }
            }}
          >
            Download Result
          </Button>
        </Paper>
      )}
    </Paper>
  );
}
